/** État de la demande d'avis Trustpilot pour l'utilisateur, au retour d'une clôture de live. */
export type TrustpilotRequestStatus = 'loading' | 'active' | 'none';

export interface PostLiveSolicitationInput {
  /** Posé par la page Live à la clôture : hors de ce contexte, seule la sollicitation interne existe. */
  isReturningFromLive: boolean;
  trustpilotStatus: TrustpilotRequestStatus;
}

/** Une seule sollicitation par clôture de live : Trustpilot prime, et l'avis interne est alors sauté
 *  pour ce live (il n'est pas reposé plus tard). */
export type PostLiveSolicitation = 'internal' | 'trustpilot' | 'waiting';

export function selectPostLiveSolicitation({
  isReturningFromLive,
  trustpilotStatus,
}: PostLiveSolicitationInput): PostLiveSolicitation {
  if (!isReturningFromLive) return 'internal';
  if (trustpilotStatus === 'loading') return 'waiting';
  return trustpilotStatus === 'active' ? 'trustpilot' : 'internal';
}
